import React, { ComponentType } from "react";
import { TextButton as TextButtonComponent } from "@/app/components/storybook/Button/TextButton";
import { TextButtonProps } from "@/app/interfaces/props/TextButtonProps";
import { ElementSizeTokensEnum } from "@/enums/tokens/elementSizeTokensEnum";
import { StateTokensEnum } from "@/enums/tokens/stateTokensEnum";
import { ColorTokensEnum } from "@/enums/tokens/colorTokensEnum";
import { CommonHelper } from "../../../../stories/helpers/CommonHelper";

const iconMap: Record<string, ComponentType<any>> = CommonHelper.getFlattenedIcons(false);
const iconNames = CommonHelper.getSortedIconNames();

const textButtonStates = [
  StateTokensEnum.DEFAULT,
  StateTokensEnum.HOVER,
  StateTokensEnum.FOCUS,
  StateTokensEnum.DISABLED,
];

const TextButton: React.FC<TextButtonProps> = ({
  label = "Button",
  size = ElementSizeTokensEnum.DEFAULT,
  state = StateTokensEnum.DEFAULT,
  color,
  iconSize,
  leftIcon,
  rightIcon,
}) => {
  const ResolvedLeftIcon = leftIcon ? iconMap[leftIcon as string] : undefined;
  const ResolvedRightIcon = rightIcon ? iconMap[rightIcon as string] : undefined;

  return (
    <TextButtonComponent
      label={label}
      size={size}
      state={state}
      color={color}
      iconSize={iconSize}
      leftIcon={ResolvedLeftIcon}
      rightIcon={ResolvedRightIcon}
    />
  );
};

export default TextButton;

export const textButtonRegistration = {
  name: "Text Button",
  inputs: [
    {
      name: "label",
      type: "string",
      defaultValue: "Button",
    },
    {
      name: "size",
      type: "string",
      enum: [
        ElementSizeTokensEnum.SMALL,
        ElementSizeTokensEnum.DEFAULT,
        ElementSizeTokensEnum.LARGE,
      ],
      defaultValue: ElementSizeTokensEnum.DEFAULT,
    },
    {
      name: "state",
      type: "string",
      enum: textButtonStates,
      defaultValue: StateTokensEnum.DEFAULT,
    },
    {
      name: "color",
      type: "string",
      enum: Object.values(ColorTokensEnum),
      defaultValue: ColorTokensEnum.DARKEST_GREY,
    },
    {
      name: "iconSize",
      type: "number",
      defaultValue: 20,
    },
    {
      name: "leftIcon",
      type: "string",
      enum: iconNames,
    },
    {
      name: "rightIcon",
      type: "string",
      enum: iconNames,
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/format-text.svg",
  description: "Add a text button component to the page",
};
